import { LightTheme } from '../styles';

export const useAppTheme = () => {
  return LightTheme;
};
